import { useState } from 'react';
import dayjs from 'dayjs';
import Alert from '@liquidweb-dev/undercurrent/Alert';
import AlertTitle from '@liquidweb-dev/undercurrent/AlertTitle';
import Button from '@liquidweb-dev/undercurrent/Button/Button';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import DialogScheduledCancellation from 'components/DialogScheduledCancellation/DialogScheduledCancellation';
import useScheduledCancellationFlag from 'components/CancellationScheduledServerList/useScheduledCancellationFlag';

interface CancellationAlertProps {
	uniqId: string;
	cancellationDate?: string | null;
	title?: string;
	nextRenewalDate?: string | null;
}

const CancellationAlert = ({
	uniqId,
	cancellationDate,
	title,
	nextRenewalDate,
}: CancellationAlertProps) => {
	const [cancellationDialog, setCancellationDialog] = useState(false);
	const isScheduledCancellationFlagEnabled = useScheduledCancellationFlag();

	// if flag is not set, do not display the alert within server interior
	if (!isScheduledCancellationFlagEnabled) {
		return null;
	}

	return (
		<Alert
			severity="warning"
			sx={(vars) => ({
				background: vars.palette.uc.warning.bg.main,
				borderRadius: 0,
				borderStyle: 'none',
				padding: 200,
			})}
			action={
				<Button
					variant="primary"
					size="medium"
					onClick={() => setCancellationDialog(true)}
				>
					Keep my service
				</Button>
			}
		>
			<AlertTitle>
				Cancellation scheduled for{' '}
				<strong>{dayjs(cancellationDate).format('MMMM D, YYYY')}</strong>
			</AlertTitle>
			<Typography variant="body-sm" sx={{ fontWeight: 400 }}>
				Your server will remain available until your billing cycle ends. No
				refund will be issued.
			</Typography>

			<DialogScheduledCancellation
				open={cancellationDialog}
				uniqId={uniqId}
				onClose={() => setCancellationDialog(false)}
				serverName={title}
				nextRenewalDate={nextRenewalDate}
			/>
		</Alert>
	);
};

export default CancellationAlert;
